import { type UseQueryResult, useQuery } from 'react-query';
import { CustomerTitleService } from '../../services/wealthlane-customer-services';

const useGetAllJobTitles = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const allJobTitleOptions = useQuery(
    ['getAllJobTitleOptions'],
    async () => {
      return await handleRequest(
        CustomerTitleService.getApiCustomerApiAppCustomerTitleCustomerTitles()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return allJobTitleOptions;
};

export default useGetAllJobTitles;
